import * as React from 'react';

import { DataTable, Page, PageContent, PageHeader, Table } from '../../components/common';
import { TextInput } from '../../components/forms';
import { IconButton } from '../../components/buttons';
import { IconEdit } from '../../components/icons';

interface Props {
	groups?: Array<any>;
	actions: any;
	history: any;
}
class GroupListPage extends React.Component<Props, any> {
	render() {
		const { ...props } = this.props;
		return (
			<Page title="Groups">
				<PageContent>
					<PageHeader title="Groups" className="page-header-sm" />
					{props.groups &&
						props.groups.length > 0 && (
							<div className="row">
								<div className="col-md-6 col-lg-4">
									<TextInput name="search" placeholder="Search" className="m-0" />
								</div>
							</div>
						)}
					<DataTable
						TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
						columns={[
							{
								accessor: 'id',
								show: false
							},
							{
								Header: 'Group name',
								accessor: 'name'
							},
							{
								Header: 'Actions',
								className: 'p-0 td-actions',
								Cell: (rowInfo: any) => (
									<IconButton
										title="View rate table"
										className="btn-icon-secondary btn-icon-td"
										onClick={(e: any) => {
											e.stopPropagation(); // Prevent onClick conflict with tr onclick
											props.history.push(`/admin/group/${rowInfo.row.id}`);
										}}
									>
										<IconEdit />
									</IconButton>
								)
							}
						]}
						getTrProps={(state: any, rowInfo: any, column: any) => {
							return {
								className: 'tr interactive',
								onClick: () => props.history.push(`/admin/group/${rowInfo.row.id}`)
							};
						}}
						data={props.groups}
						noDataText="No groups found"
					/>
				</PageContent>
			</Page>
		);
	}
}
export default GroupListPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/groups/GroupListPage.tsx